import type { ExtendedSeriesOptionsType } from '@/features/_shared/chart/types/highcharts';

export const getSeriesId = (series: ExtendedSeriesOptionsType): string | undefined => {
  if (series.id) return series.id;
  if (series.name) return series.name;
  return undefined;
};

export const applySeriesVisibility = (
  series: ExtendedSeriesOptionsType[] | undefined,
  hiddenSeriesIds: string[]
): ExtendedSeriesOptionsType[] | undefined => {
  if (!series) return series;
  return series.map(item => {
    const seriesId = getSeriesId(item);
    if (!seriesId) return item;
    const visible = !hiddenSeriesIds.includes(seriesId);
    if (item.visible === visible) return item;
    return { ...item, visible };
  });
};
